import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Loader from '../../component/layout/Loader'
import { toast } from 'react-toastify'
import IconCaretsDown from '../../component/icon/IconCaretsDown'
import AnimateHeight from 'react-animate-height'
import Dropdown from '../../component/Dropdown'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import api from '../../api/api'
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const ProfileView = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [coachData, setCoachData] = useState({
        fullName:"",
        email: "",
        phoneNumber: "",
        city: "",
        dob: new Date(),
        verified: false,
        ic: "",
        assigned_info: null,
        profilePic: "",
        bank: "0",
        bankName: "",
        bankAccountNumber: "",
        bankAccountName: "",
        profile_pic: "",
        bio: "",
        
    })
    const [bankList, setBankList] = useState([])

    useEffect(() => {
        getCoachDetail()
        getBanks()
    }, [])
    
    
    const getBanks = async () => {
        api.get(`${process.env.REACT_APP_API_BASE_URL}/bank`).then( res => {
            console.log("bank 21", res.data.data)
            setBankList(res.data.data)
        }).catch( err => {
            console.log("err", err)
            toast.error(t("server_error"))
        })
    }

    const getCoachDetail = async () => {
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/user/profile`).then( res => {
            console.log("res 21", res.data.data)
            setCoachData({
                fullName: res.data.data.name,
                email: res.data.data.email,
                city: res.data.data.city,
                phoneNumber: res.data.data.phone,
                dob: res.data.data.birth_date || new Date(),
                verified: res.data.data.is_approved,
                ic: res.data.data.ic_number,
                assigned_info: res.data.data.assigned_info,
                profilePic: res.data.data.profile_pic,
                bank: res.data.data.bank || "0",
                bankName: res.data.data.bank_name,
                bankAccountNumber: res.data.data.bank_account_number,
                bankAccountName: res.data.data.bank_account_name,
                profile_pic: res.data.data.profile_pic,
                bio: res.data.data.bio || "",
            })

        }).catch( err => {
            console.log("err", err)
            toast.error(t("server_error"))
        }).finally(()=>{
            setLoading(false)
        })
    }
    
    const updateCoach = async (values:any) => {
        if (values.bank == "0") {
            return toast.warn("Please select a bank")
        }

        const date = new Date(values.dob)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, "0") // getMonth is 0-based
        const day = String(date.getDate()).padStart(2, "0")
        const formatted = `${year}-${month}-${day}`

        let payload :any = {
            "name": values.fullName,
            "email": values.email.trim(),
            "city": values.city,
            "phone": values.phoneNumber,
            "birth_date": formatted,
            "ic_number": values.ic,
            "assigned_info": values.assigned_info,
            "bank": values.bank,
            "bank_account_number": values.bankAccountNumber,
            "bank_account_name": values.bankAccountName,
            "bio": values.bio
        }

        
        // Check if profile_pic is Base64 data
        if (coachData.profile_pic && coachData.profile_pic.startsWith("data:")) {
            payload["profile_pic"] = coachData.profile_pic
        }

        setLoading(true)
        console.log("payload", payload)
        api.put(`${process.env.REACT_APP_API_BASE_URL}/user/profile`, payload).then( res => {
            console.log("res", res.data)
            toast.success(t("update_success"))

        }).catch( err => {
            console.log("err", err)
            if (err.response && err.response.data && err.response.data.errors) {
                const errors = err.response.data.errors
                Object.keys(errors).forEach(key => {
                    errors[key].forEach((message:string) => {
                        toast.error(`${key} : ${message}`)
                    })
                })
            } else {
                toast.error(t("server_error"))
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const [active, setActive] = useState<string>('0');
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")

    const togglePara = (value: string) => {
        setActive((oldValue) => {
            return oldValue === value ? '' : value;
        });
    }
    
    function handleChangePassword() {
        if (newPassword !== confirmPassword) return toast.error(t("profile.password_not_match"))

        setLoading(true)
        api.post(`${process.env.REACT_APP_API_BASE_URL}/user/change-password`, {
            "password": newPassword,
            "confirm_password": confirmPassword
        }, {
            headers: {
                "Authorization": localStorage.getItem("coach_token"),
                "Content-Type": "application/json"
            }
        }).then(res => {
            setNewPassword("")
            setConfirmPassword("")
            toast.success(t("profile.success_change_password"))
            
        }).catch(err =>{
            console.log("err", err)
            toast.error(t("server_error"))

        }).finally(() => {
            setLoading(false)
        })
    }

    const handleImageChange = (e:any) => {
        const file = e.target.files[0];
        if (file) {
            const validExtensions = ["image/jpeg", "image/png", "image/jpg"]
            if (!validExtensions.includes(file.type)) return toast.error("Only JPG and PNG images are allowed.")

            const maxFileSize = 3 * 1024 * 1024 // 1 MB in bytes
            if (file.size > maxFileSize) return toast.error("Image size should not exceed 3 MB")
            
            const reader = new FileReader();
            reader.onloadend = () => {
                setCoachData((prevData:any) => ({
                    ...prevData,
                    profile_pic: reader.result,
                }));
            };
            reader.readAsDataURL(file)
        }
    }

    const validationSchema = Yup.object().shape({
        fullName: Yup.string().required(t("validation.required")),
        email: Yup.string().email("Invalid email").required(t("validation.required")),
        ic: Yup.string().required(t("validation.required")),
        phoneNumber: Yup.string().matches(/^\d{10}|\d{12}$/, t("validation.invalid_phone")).required(t("validation.required")),
        city: Yup.string().required(t("validation.required")),
        dob: Yup.date().required(t("validation.required")),
        bank: Yup.string().required(t("validation.required")),
        bankAccountNumber: Yup.string().required(t("validation.required")),
        bankAccountName: Yup.string().required(t("validation.required")),
        newPassword: Yup.string().min(6, t("validation.password_min")),
        confirmPassword: Yup.string().oneOf([Yup.ref("newPassword")], t("validation.password_mismatch")),
        bio: Yup.string().required(t("validation.required")),
    });

    
    return (
        <div>
            {loading && <Loader/>}
            <ul className="flex space-x-2 rtl:space-x-reverse">
                <li>
                    <span>{t('profile.coach_settings')}</span>
                </li>
            </ul>
            <div className="pt-5">
                <Formik
                    enableReinitialize
                    initialValues={{
                        fullName: coachData.fullName || "",
                        email: coachData.email || "",
                        ic: coachData.ic || "",
                        phoneNumber: coachData.phoneNumber || "",
                        city: coachData.city || "",
                        dob: coachData.dob || "",
                        bank: coachData.bank || "",
                        bankAccountNumber: coachData.bankAccountNumber || "",
                        bankAccountName: coachData.bankAccountName || "",
                        bio: coachData.bio || "",
                        newPassword: "",
                        confirmPassword: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => updateCoach(values)}
                >
                    {({ setFieldValue, values }) => (
                        <Form className="border border-[#ebedf2] dark:border-[#191e3a] rounded-md p-4 mb-5 bg-white dark:bg-black">
                            <div className="flex flex-col sm:flex-row">
                                <div className="relative w-20 h-20 md:w-32 md:h-32 mx-auto mb-5 sm:mr-4" onClick={() => document.getElementById("fileInput")!.click()} >
                                    <img src={coachData.profile_pic || "/assets/dummy/default-profile.jpg"} alt="Profile" className="w-full h-full rounded-full object-cover" />
                                    <input id="fileInput" type="file" accept=".jpg,.jpeg,.png" className="hidden" onChange={handleImageChange} />
                                </div>
                                <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-5">
                                    <div>
                                        <label>Full Name</label>
                                        <Field name="fullName" type="text" className="form-input" />
                                        <ErrorMessage name="fullName" component="div" className="text-red-500" />
                                    </div>
                                    <div>
                                        <label>Email</label>
                                        <Field name="email" type="email" className="form-input" 
                                        onChange={(e:any) => {
                                            const noSpaceValue = e.target.value.replace(/\s/g, '')
                                            setFieldValue("email", noSpaceValue, true)
                                        }}/>
                                        <ErrorMessage name="email" component="div" className="text-red-500" />
                                    </div>
                                    <div>
                                        <label>Identification Number</label>
                                        <Field name="ic" type="text" className="form-input"
                                        onChange={(e:any) => {
                                            const alphanumericValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
                                            setFieldValue("ic", alphanumericValue, true)
                                        }} />
                                        <ErrorMessage name="ic" component="div" className="text-red-500" />
                                    </div>
                                    <div>
                                        <label>Phone Number</label>
                                        <Field name="phoneNumber" type="text" className="form-input" 
                                        onChange={(e:any) => {
                                            const numericValue = e.target.value.replace(/\D/g, '')
                                            setFieldValue("phoneNumber", numericValue, true)
                                        }}/>
                                        <ErrorMessage name="phoneNumber" component="div" className="text-red-500"
                                         />
                                    </div>
                                    <div>
                                        <label>City</label>
                                        <Field name="city" type="text" className="form-input" />
                                        <ErrorMessage name="city" component="div" className="text-red-500" />
                                    </div>
                                    <div>
                                        <label>Date of Birth</label>
                                        <DatePicker onChange={(date) => setFieldValue("dob", date)} value={values.dob} className="form-input" />
                                        <ErrorMessage name="dob" component="div" className="text-red-500" />
                                    </div>
                                    <div>
                                        <label>Bank Name</label>
                                        <Field name="bank" as="select" className="form-select">
                                            <option value="">-- Select Bank --</option>
                                            {bankList.map((bank:any, index:number) => {
                                                return (
                                                    <option key={index} value={bank.id}>{bank.name}</option>
                                                )
                                            })}
                                        </Field>
                                        <ErrorMessage name="bank" component="div" className="text-red-500" />
                                    </div>
                                    <div>
                                        <label>Bank Account Number</label>
                                        <Field name="bankAccountNumber" type="text" className="form-input" />
                                        <ErrorMessage name="bankAccountNumber" component="div" className="text-red-500" />
                                    </div>
                                    <div>
                                        <label>Bank Account Name</label>
                                        <Field name="bankAccountName" type="text" className="form-input" />
                                        <ErrorMessage name="bankAccountName" component="div" className="text-red-500" />
                                    </div>
                                    <div className="sm:col-span-2">
                                        <label>Bio</label>
                                        <Field name="bio" as="textarea" rows="4" className="form-input" placeholder="Tell us about yourself..." />
                                        <ErrorMessage name="bio" component="div" className="text-red-500" />
                                    </div>
                                    <div className="sm:col-span-2 flex mt-3 gap-2">
                                        <button type="button" onClick={() => navigate("/")} className="btn btn-secondary">Back</button>
                                        <button type="submit" className="btn btn-primary">Update</button>
                                    </div>
                                </div>
                            </div>
                            <div className="dropdown mt-5">
                                <Dropdown
                                    placement={`bottom-end`}
                                    innerClassName="z-50 w-full"
                                    btnClassName="border border-[#d3d3d3] rounded dark:border-[#1b2e4b] p-3 w-full"
                                    button={
                                        <>
                                            <div>{t('profile.language')}</div>
                                            <div className='ml-auto'>
                                                <IconCaretsDown className="ltr:ml-1 rtl:mr-1 inline-block" />
                                            </div>
                                        </>
                                    }
                                >
                                    <ul className=" w-full divide-y ">
                                        <li onClick={(e) => { i18next.changeLanguage("en"); }}>
                                            <button type="button" className="place-content-start">
                                                English
                                            </button>
                                        </li>
                                        <li  onClick={(e) => { i18next.changeLanguage("zh"); }}>
                                            <button type="button" className="place-content-start">
                                                Mandarin
                                            </button>
                                        </li>
                                        <li  onClick={(e) => { i18next.changeLanguage("ms"); }}>
                                            <button type="button" className="place-content-start">
                                                Malay
                                            </button>
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                        </Form>
                    )}
                </Formik>

                
            </div>
        </div>
    )
}

export default ProfileView